import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import { useCrm_task_priorities } from "../../../../hooks";

const FormWrapper = ({
  onSubmit = () => {},
  onFinishFailed = () => {},
  children,
  onChange,
  refreshFormTimestamp,
  activityType,
}) => {
  const [form] = Form.useForm();
  const priorities = useCrm_task_priorities();

  const getNormalPriorityId = () => {
    return priorities?.find(({ name }) => name === "normal")?.id;
  };

  useEffect(() => {
    form.resetFields();
    if (activityType === "task") {
      const normalPriorityId = getNormalPriorityId();
      form.setFieldsValue({ priority_id: normalPriorityId });
    }
  }, [refreshFormTimestamp, priorities, activityType, form]);

  const onValuesChange = useCallback(
    (values, all) => {
      onChange?.(values, all);
    },
    [onChange]
  );

  return (
    <Form
      layout="vertical"
      onFinish={onSubmit}
      onFinishFailed={onFinishFailed}
      scrollToFirstError
      onValuesChange={onValuesChange}
      form={form}
    >
      {children}
    </Form>
  );
};

FormWrapper.propTypes = {
  onSubmit: PropTypes.func,
  onFinishFailed: PropTypes.func,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  refreshFormTimestamp: PropTypes.string,
  activityType: PropTypes.string,
};

export default FormWrapper;
